export default __webpack_public_path__ + "static/media/A11.22934385.jpg";